module.exports = __webpack_public_path__ + "static/media/background-pagamentos3-mobile.3276e2c4.jpg";